import React from "react";
import Img from "../../assets/PaymentSuccess.png";
import { Link } from "react-router-dom";

export default function PaymentSuccess() {
  return (
    <div className="container py-5">
      <div className="row align-items-center">
        <div className="col-12 col-lg-6 mb-5 mb-lg-0">
          <h1 className="brand-dark-purple fw-bold display-5 mb-3">
            Payment successful
          </h1>

          <p className="text-muted fs-5 mb-4">
            We will get started on your project right away.
          </p>

          <div className="d-flex flex-wrap gap-3">
            <Link to="/" className="btn brand-purple-inline min-width">
              {" "}
              Back to home
            </Link>
          </div>
        </div>

        <div className="col-12 col-lg-6 text-center">
          <img
            src={Img}
            alt="Payment successful"
            className="illustration-img"
          />
        </div>
      </div>
    </div>
  );
}
